import { ComboBoxDropDownItem } from "@/Common/Components/Inputs/Combobox";

class ConsentPrograms {
    public model: ConsentProgramsData;

    constructor(model: ConsentProgramsData) {
        this.model = model;
    }

    public getName(): string {
        let returnValue = "";

        if (this.model != null) {
            if (sessionStore.userLanguageCode === "fr") {
                returnValue = this.model.NameFr;
            }
            else if (sessionStore.userLanguageCode === "en") {
                returnValue = this.model.NameEn;
            }
            else if (sessionStore.userLanguageCode === "es-MX") {
                returnValue = this.model.NameEs;
            }
        }

        return returnValue;
    }

    public static toComboboxItem(model: ConsentPrograms): ComboBoxDropDownItem {
        return new ComboBoxDropDownItem(model.model.Id.toString(), model.getName(), 0);
    }
}

class ConsentProgramsData {
    public Id: number;
    public NameFr: string;
    public NameEn: string;
    public NameEs: string;
    public IsDocRequired: boolean;
    public Code: string;
}

export { ConsentPrograms, ConsentProgramsData };
